<script>
import {defineComponent} from 'vue'
import ApiRequest from "@/core/api-request";
import SelectBox from "@/components/layout/form_inputs/SelectBox.vue";
import Alert from "@/components/layout/Alert";

export default defineComponent({
  name: "CheckInIndex",
  components: {SelectBox},

  data() {
    return {
      search: {
        timeout_id: null,
      },
      truck_no: '',
      selected_hawb: [],
      check_at: this.$moment(new Date()).format('YYYY-MM-DD HH:mm:SS'),
      hawbs: [],
      hawb_loading: false,
      notes: [],
      note_loading: false,
    }
  },
  mounted() {
    this.fetchNote();
  },
  methods: {
    fetchHawb(search) {
      this.hawb_loading = true;
      ApiRequest.get({
        uri: '/check-in/hawb', params: {
          search: search
        }, loadingE: false
      }).then((res) => {
            this.hawb_loading = false;
            this.hawbs = res.hawb;
          }
      ).catch((e) => {
        console.error(e)
        this.hawb_loading = false;
      });
    },
    fetchNote() {
      this.note_loading = true;
      ApiRequest.get({
        uri: '/check-in/pin-notes', params: {}, loadingE: false
      }).then((res) => {
            this.note_loading = false;
            this.notes = res.pin_notes;
          }
      ).catch((e) => {
        console.error(e)
        this.hawb_loading = false;
      });
    },
    clear() {
      this.selected_hawb = [];
      this.check_at = null;
      this.truck_no = '';
    },
    onSearchChange(query) {
      if (this.search.timeout_id) {
        clearTimeout(this.search.timeout_id);
      }
      this.search.timeout_id = setTimeout(() => {
        this.fetchHawb(query);
      }, 400);

    },
    hawbChange(data) {
      if (!data) return;
      if (!this.selected_hawb.some(e => e.Id === data.Id)) {
        let row = {...data};
        row._pcs = data.Pcs;
        row.note_pin = []; // Initialize note_pin as an empty array
        switch (data.Agent.toUpperCase()) {
          case 'KGL':
            row.location_storage = "Kho 12";
            break;
          case 'APEX':
            row.location_storage = "Kho 4";
            break;
          case 'EI':
            row.location_storage = "Kho 56";
            break;
          case 'GEO':
            row.location_storage = "Kho 7";
            break;
        }
        this.selected_hawb.push(row);
      }
    },
    removeHabw(hawb) {
      console.log(hawb, this.selected_hawb)
      this.selected_hawb = this.selected_hawb.filter(selected_hawb => selected_hawb.Id !== hawb.Id);
      console.log(hawb, this.selected_hawb)
    },
    submit() {
      let list_hawb = this.selected_hawb.map((item) => {
        return {
          plan_id: item.Id,
          pcs: item._pcs,
          is_pin: item.is_pin ?? false,
          note_pin: JSON.stringify(item.note_pin) ?? null,
          location_storage: item.location_storage,
        }
      });
      let data = {
        "license_plates": this.truck_no,
        "unloading_at": this.$moment(this.check_at).format('YYYY-MM-DD HH:mm'),
        "list_hawb": list_hawb
      }
      ApiRequest.post({uri: '/unloading', data: data}).then(() => {
        Alert.success({message: 'Xử lý thành công'});
        this.clear();
      }).catch((e) => {
        console.error(e)
      });
    }
  }
})
</script>

<template>
  <div class="px-4">
    <h4 class="text-orange">Check In</h4>
    <div class="form-group">
      <label>Biển số xe</label>
      <input type="text" class="form-control" v-model="truck_no">
    </div>
    <div class="form-group">
      <label>Hawb</label>
      <select-box class="mb-3" :options="hawbs" :display-field="'Hawb'" :value-field="'Hawb'" @change="hawbChange"
                  :loading="hawb_loading"
                  :on-search-change="onSearchChange"></select-box>


      <template v-for='hawb in selected_hawb' :key="hawb.Id">
        <fieldset class="border rounded container mb-2" style="position: relative;">
          <legend class="ml-2 mb-0 w-auto text-md"><b class="my-auto text-orange">{{ hawb.Hawb }}</b> - Total PCS:
            <b class="text-success">{{ hawb.Pcs }}</b>

          </legend>
          <button style="position: absolute; top: -28px ; right: 5px" class="btn btn-sm bg-white "
                  @click="removeHabw(hawb)"><i
              class="fas fa-times-circle text-danger fa-lg"></i>
          </button>
          <div class="row">
            <div class="form-group col-5">
              <label class="mb-0">PCS</label>
              <input type="number" class="form-control form-control-sm" v-model="hawb._pcs">
            </div>
            <div class="form-group col-7">
              <label class="mb-0">Đểm lưu kho</label>
              <select class="form-control form-control-sm" v-model="hawb.location_storage">
                <option value="">-- Hãy chọn --</option>
                <option value="Kho 12">Kho 12</option>
                <option value="Kho 4">Kho 4</option>
                <option value="Kho 56">Kho 56</option>
                <option value="Kho 7">Kho 7</option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-12">
              <div class="form-group clearfix">
                <div class="custom-checkbox-container">
                  <input type="checkbox" id="customCheckbox" class="custom-checkbox" v-model="hawb.is_pin">
                  <label for="customCheckbox" class="custom-checkbox-label mb-0">
                    Có Pin
                  </label>
                </div>
              </div>
            </div>
            <div class="form-group col-12" v-if="hawb.is_pin">
              <label class="mb-0">Note pin</label>
              <select-box class="mb-3"
                          v-model="hawb.note_pin"
                          :multiple="true"
                          :options="notes" :display-field="'note'" :value-field="'code'"
                          :loading="note_loading"
              ></select-box>
              <!--              <textarea class="form-control form-control-sm" v-model="hawb.note_pin" required></textarea>-->
            </div>
          </div>
        </fieldset>
      </template>

      <!--      <div class="border mt-2 p-2 d-flex flex-column" style="min-height: 100px;max-height: 200px; overflow-y: auto">-->
      <!--        <table>-->
      <!--          <tr>-->
      <!--            <th width="1px"></th>-->
      <!--            <th>Hawb</th>-->
      <!--            <th>Pcs</th>-->
      <!--            <th></th>-->
      <!--            <th>Điểm lưu kho</th>-->

      <!--          </tr>-->
      <!--          &lt;!&ndash;          <tr v-for="hawb in selected_hawb" :key="hawb.Id">&ndash;&gt;-->
      <!--          <template v-for='hawb in [-->
      <!--            {-->
      <!--                "Id": 113510,-->
      <!--                "Hawb": "KHAN24075346",-->
      <!--                "Pcs": 1,-->
      <!--                "Agent": "KGL"-->
      <!--            }-->
      <!--        ]' :key="hawb.Id">-->
      <!--            <tr>-->
      <!--              <td>-->
      <!--                <div class="d-flex">-->
      <!--                  <button class="btn btn-sm btn-link text-danger" @click="removeHabw(hawb)"><i-->
      <!--                      class="fas fa-times-circle"></i>-->
      <!--                  </button>-->
      <!--                  <b class="mr-2 my-auto text-orange">{{ hawb.Hawb }}</b></div>-->
      <!--                <b-->
      <!--              </td>-->
      <!--              <td>{{ hawb.Pcs }}</td>-->
      <!--              <td width="60px"><input type="number" class="form-control form-control-sm" v-model="hawb._pcs"></td>-->
      <!--              <td width="60px">-->
      <!--                <select class="form-control form-control-sm">-->
      <!--                  <option value="Kho 12">Kho 12</option>-->
      <!--                  <option value="Kho 4">Kho 12</option>-->
      <!--                  <option value="Kho 56">Kho 12</option>-->
      <!--                </select>-->
      <!--                &lt;!&ndash;              <select-box class="form-control-sm" :options="[{id:'Kho 12', name:'Kho 12'},{id:'Kho 4',name:'Kho 4'},{id:'Kho 56',name:'Kho 56'}]"&ndash;&gt;-->
      <!--                &lt;!&ndash;                          v-model="hawb.location_storage"&ndash;&gt;-->
      <!--                &lt;!&ndash;                          :loading="hawb_loading"></select-box>&ndash;&gt;-->
      <!--              </td>-->
      <!--            </tr>-->
      <!--          </template>-->

      <!--        </table>-->
      <!--      </div>-->
    </div>
    <div class="form-group">
      <label>Ngày giờ</label>
      <input type="datetime-local" class="form-control" v-model="check_at">
    </div>
    <div class="">
      <button class="btn btn-success w-100" @click="submit">Xác nhận</button>
    </div>
  </div>
</template>

<style scoped>
.custom-checkbox-container {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.custom-checkbox {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 24px;
  height: 24px;
  border: 2px solid #007bff;
  border-radius: 4px;
  outline: none;
  cursor: pointer;
  position: relative;
  margin-right: 10px;
  vertical-align: middle;
  transition: all 0.2s ease;
}

.custom-checkbox:checked {
  background-color: #007bff;
  border-color: #007bff;
}

.custom-checkbox:checked::after {
  content: '✓';
  position: absolute;
  color: white;
  font-size: 18px;
  left: 5px;
  top: -2px;
}

.custom-checkbox-label {
  font-size: 16px;
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
}
</style>
